import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const QuestionIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);

  return (
    <svg
      className={classes.ico}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M24.8848 7.53125H24.2268V12.6465C24.2268 16.4364 21.1435 19.5196 17.3537 19.5196H7.53125V20.1779C7.53125 22.9984 9.82602 25.2929 12.6465 25.2929H23.1545L28.5586 29.7964C28.7195 29.9305 28.9196 30.0001 29.1214 30.0001C29.6046 30.0001 30.0001 29.608 30.0001 29.1212V12.6465C30.0001 9.82167 27.7147 7.53125 24.8848 7.53125Z"
          fill={currentColor}
        />
        <path
          d="M22.4689 12.6464V5.11528C22.4689 2.28539 20.1787 0 17.3536 0H5.11528C2.28539 0 0 2.29019 0 5.11528V21.59C0 22.0766 0.395508 22.4689 0.878677 22.4689C1.08055 22.4689 1.28059 22.3993 1.4415 22.2649L6.84563 17.7617H17.3536C20.1741 17.7617 22.4689 15.4671 22.4689 12.6464ZM11.2344 13.9961C10.7492 13.9961 10.3555 13.6024 10.3555 13.1172C10.3555 12.632 10.7492 12.2383 11.2344 12.2383C11.7194 12.2383 12.1133 12.632 12.1133 13.1172C12.1133 13.6024 11.7194 13.9961 11.2344 13.9961ZM12.1133 10.109V10.293C12.1133 10.7783 11.7197 11.172 11.2344 11.172C10.749 11.172 10.3555 10.7783 10.3555 10.293V9.35165C10.3555 8.8662 10.749 8.47275 11.2344 8.47275C12.0474 8.47275 12.7089 7.81105 12.7089 6.99806C12.7089 6.18484 12.0474 5.52338 11.2344 5.52338C10.8398 5.52338 10.4697 5.67673 10.1914 5.95505C9.9131 6.23337 9.75975 6.60347 9.75975 6.99692C9.75975 7.48238 9.3663 7.87651 8.88084 7.87651C8.39539 7.87651 8.00194 7.48329 8.00194 6.99806V6.99692C8.00194 6.13403 8.33817 5.32242 8.94836 4.71222C9.55879 4.10179 10.3702 3.76556 11.2333 3.76556C13.0167 3.76556 14.4667 5.21576 14.4667 6.99806C14.4667 8.47595 13.4699 9.72542 12.1133 10.109Z"
          fill={currentColor}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
